import './style.scss'

const MmRating = ({ number, action = undefined }) => {

  const stars = Array.from({ length: 5 }, (_, index) => {
    const isRed = index < number
    const starClass = `icon icon--star${isRed ? ' cPrimary' : ''}`
    return <i key={index} className={starClass}></i>
  })

  return (
    <div className='mmrating' onClick={action}>
      <div className='mmrating__title --secFont'>MM Score:</div>
      <div className='mmrating__stars'>{stars}</div>
    </div>
  )
}

export default MmRating
